window.onload = function (e) {

	const toTop = document.getElementById('to-top');
	if (toTop) {
		window.addEventListener('scroll', function (e) {
			if (window.scrollY > 300) {
				toTop.classList.add('show');
			} else {
				toTop.classList.remove('show');
			}
		});
	}
	
};
